import { useDispatch, useSelector } from "react-redux";
import { getGateways, getSensors } from "../../Api Methods/Api";
import { useEffect, useState } from "react";
import { Await } from "react-router-dom";
import PadlocksList from "../Padlocks/padlocksList";
import DeviceLoadingGrid from "../../components/GridList/DeviceLoadingGrid";
import Stats2 from "../../components/UI/Stats/Stats2";
import mixpanel from "mixpanel-browser";

const Gateways = () => {

    const dispatch = useDispatch();
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const apiData = {
        token,
        client
    }

    const [gateways, setGateways] = useState([])
    const [billableGateways, setBillableGateways] = useState(0)
    const [nonBillableGateways, setNonBillableGateways] = useState(0)
    const [criticalGateways, setCriticalGateways] = useState([])
    const [warningGateways, setWarningGateways] = useState([])
    const [healthyGateways, setHealthyGateways] = useState([]) 
    const [offlineGateways, setOfflineGateways] = useState([])
    const [staleGateways, setStaleGateways] = useState([])
    const [update, setUpdate] = useState(0)
    const filtering = ""
    const [isLoading, setIsLoading] = useState(true)
    const [counts, setCounts] = useState([])

    //Pull data on mount
    useEffect(() => {
        const HandleGetGateways = async () => {
            const response = await getGateways(apiData, dispatch);
            console.log(response.data[0]);
            // console.log(JSON.parse(response.data[0][0].result));
            // const parsed = JSON.parse(response.data[0][0].result);
            // setGateways(parsed.data);
            // setCounts(parsed.counts)
            // console.log(counts);
            setBillableGateways(response.data[0].filter(lock => lock.billable == 1))
            setNonBillableGateways(response.data[0].filter(lock => lock.billable == 0))
            setCriticalGateways(response.data[0].filter(lock => lock.battery <= 10))
            setWarningGateways(response.data[0].filter(lock => lock.battery > 10 && lock.battery < 30))
            setHealthyGateways(response.data[0].filter(lock => lock.battery >= 30))
            setOfflineGateways(response.data[0].filter(lock => lock.status == "stale"))
            setStaleGateways(response.data[0].filter(lock => lock.status == "potentiallyStale"))
            setGateways(response.data[0])
            setIsLoading(false)
        }

        HandleGetGateways();
   
        mixpanel.track("Gateways tab visited", {
            user: localStorage.getItem('email')
        });
    }, [update])


    return (
        <Await resolve={gateways}>
                <div style={{ width: "100%" }}>
                    <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
                        <Stats2 title={"Total gateways"} value={gateways.length}  isLoadingStats={isLoading} isStatic={true} />
                        <Stats2 title={"Offline gateways"} value={offlineGateways.length}  isLoadingStats={isLoading} isStatic={true} />
                        <Stats2 title={"Check-in missed"} value={staleGateways.length}  isLoadingStats={isLoading} isStatic={true} />
                        <Stats2 title={"Critical (<10% battery)"} value={criticalGateways.length}  isLoadingStats={isLoading} isStatic={true} />
                        <Stats2 title={"Warning (<30% battery)"} value={warningGateways.length}  isLoadingStats={isLoading} isStatic={true} />
                        <Stats2 title={"Healthy (>30% battery)"} value={healthyGateways.length}  isLoadingStats={isLoading} isStatic={true} />
                        
                        <Stats2 title={"Billable "} value={billableGateways.length}  isLoadingStats={isLoading} isStatic={true} />
                        <Stats2 title={"Non-billable"} value={nonBillableGateways.length}  isLoadingStats={isLoading} isStatic={true} />

                    </div>
                   
                    <br></br>
                    {isLoading ? (
                        <div style={{ display: "flex", width: "100%" }}>
                            <DeviceLoadingGrid
                                CardCount={20}
                            />
                        </div>
                        ) : (
                            <PadlocksList 
                                locks={gateways}
                                filtering={filtering}
                                update={update}
                                setUpdate={setUpdate}
                                isGateways={true}
                            />
                        )
                    }
                </div>
           
        </Await>
    );
}


export default Gateways;